<template>
  <header id="app-header" class="flex-container flex-row align-items-center">
    <overview-toggle @clicked="menuToggled()" />
    <router-link to="/">
      <logo />
    </router-link>
    <div id="avatar" :class=" { 'row-mode' : longCompanyName } ">
      <router-link to="/account">
      <img src="../assets/img/icons/loginAvatar.svg" alt="avatar" />
      <span v-if="loggedIn">{{companyName}}</span>
      <span v-else>Anmelden</span>
      </router-link>
    </div>
  </header>
</template>

<script>
import Logo from '@/components/Logo.vue'
import OverviewToggle from '@/components/OverviewToggle.vue'

export default {
  name: 'MainHeader',
  components: {
    Logo,
    OverviewToggle
  },
  methods: {
    menuToggled: function () {
      this.$emit('toggleClicked')
    }
  },
  computed: {
    loggedIn: function () {
      return this.$root.loggedIn
    },
    companyName: function () {
      if (this.$root.currentUser.userData.companyName.length === 0) {
        return 'Willkommen'
      } else if (this.$root.currentUser.userData.companyName.length < 46) {
        return this.$root.currentUser.userData.companyName
      } else {
        return this.$root.currentUser.userData.companyName.substring(0, 43) + '...'
      }
    },
    longCompanyName: function () {
      if (this.companyName.length > 30) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped lang="scss">

@import "../assets/css/variables.scss";

#app-header {
  position: absolute;
  width: 100%;
  background: #FCFCFC;
  height: 80px;
  padding: 0 15px 0 15px;
  z-index: 99;
}

.expanded-small-overview {
  #app-header {
    position: fixed;
  }
}

#avatar {
  margin-left: auto;
  a {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: $primaryFontColor;
    font-weight: $secondaryFontNormal;
    font-family: $secondaryFont;
    width: auto;
    span {
      overflow: hidden;
      max-height: 90px;
      line-height: 1.2;
      font-size: 12px;
      max-width: 140px;
      text-align: center;
      hyphens: auto;
    }
    &:hover {
      text-decoration: none;
    }
    img {
      width: 36px;
      height: 36px;
      margin-bottom: 3px;
    }
  }
}
#avatar.row-mode {
  a {
    flex-direction: row-reverse;
    span {
      max-width: 100px;
      text-align: right;
    }
  }
  img {
    width: 36px;
    height: 36px;
    margin-bottom: 0;
    margin-left: 4px;
  }
}
@media(min-width:400px) {
  #avatar {
    a {
      span {
        font-size: 14px;
        max-width: 160px;
        hyphens: none;
      }
    }
  }
  #avatar.row-mode {
    a {
      span {
        max-width: 120px;
      }
    }
    img {
      width: 42px;
      height: 42px;
      margin-left: 6px;
    }
  }
}
@media(min-width:767px) {
  #app-header {
    height: 90px;
    position: fixed;
    padding: 0 40px 0 40px;
  }
  #avatar.row-mode {
    a {
      span {
        max-width: 160px;
      }
    }
    img {
      width: 52px;
      height: 52px;
      margin-left: 8px;
    }
  }
}
</style>
